
















































import { Vue, Component, Prop } from "@/shared/vuepack";
import { useBeneficiaryStore } from "@/employer/store/beneficiary";
import { BeneficiaryStatus, Beneficiary, BeneficiaryRelationshipType, BeneficiaryType } from "@/shared/types";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { lastFour as ssnLastFour } from "@/shared/ssn";
import _ from "lodash";
import AccountHolderWidgetBase from "@/employer/components/partner-ee-service/v2/AccountHolderWidgetBase.vue";
import Pill from "@/shared/components/ui/Pill.vue";

interface BeneficiaryTableItem {
  id: number;
  name: string;
  dateOfBirth: string;
  ssn: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  relationship: string;
  share: number;
  status: string;
  type: string;
}

@Component({
    components: {
      AccountHolderWidgetBase,
      Pill
    }
})
export default class AccountHolderBeneficiaries extends Vue {
    beneficiaryStore = useBeneficiaryStore();
    beneficiaryStatus = BeneficiaryStatus;

    @Prop({ required: true })
    username: string;

    @Prop({ required: true })
    partnerId: number;

    get isLoading () {
      return this.beneficiaryStore.isLoading;
    }

    get isLoaded () {
        return this.beneficiaryStore.isBeneficiariesLoaded;
    }

    get isFailed () {
      return this.beneficiaryStore.isFailed;
    }

    get beneficiaries (): BeneficiaryTableItem[] {
      return this.sortAndMapBeneficiaries();
    }

    get hasData () {
      return this.isLoaded && this.beneficiaries.length > 0;
    }

    loadData () {
      this.beneficiaryStore.loadBeneficiaries({
          username: this.username,
          partnerId: this.partnerId
      });
    }

    sortAndMapBeneficiaries (): BeneficiaryTableItem[] {
      const beneficiaries = Object.values(this.beneficiaryStore.beneficiaries);
      const sorted = _.sortBy(beneficiaries,
        option => option.status,
        option => option.type.toLocaleLowerCase().startsWith("c"),
        option => option.lastName
      );
      const mappedBeneficiaries = sorted.map(item => this.mapBeneficiaryForDisplay(item));
      return mappedBeneficiaries;
    }

    mapBeneficiaryForDisplay (unmappedBeneficiary: Beneficiary): BeneficiaryTableItem {
      const beneficiaryToDisplay: BeneficiaryTableItem = {
          id: unmappedBeneficiary.id,
          name: this.fullName(unmappedBeneficiary),
          dateOfBirth: formatMMddyyyyDateString(unmappedBeneficiary.dateOfBirth),
          ssn: ssnLastFour(unmappedBeneficiary.ssn),
          relationship: unmappedBeneficiary.relationshipType,
          address1: unmappedBeneficiary.address1,
          address2: unmappedBeneficiary.address2,
          city: unmappedBeneficiary.city,
          state: unmappedBeneficiary.stateCode,
          zip: unmappedBeneficiary.zip,
          share: unmappedBeneficiary.share,
          status: unmappedBeneficiary.status,
          type: unmappedBeneficiary.type
      };
      return beneficiaryToDisplay;
    }

    fullName (beneficiary: Beneficiary) {
      if (this.isEstateBeneficiary(beneficiary)) {
        return beneficiary.estateName;
      }
      return `${beneficiary.firstName} ${this.middleInitial(beneficiary)} ${beneficiary.lastName}`;
    }

    middleInitial (beneficiary: Beneficiary) {
      if (beneficiary.middleInitial) {
        return beneficiary.middleInitial;
      }
      return "";
    }

    isEstateBeneficiary (beneficiary: Beneficiary): boolean {
      return beneficiary.relationshipType === BeneficiaryRelationshipType.Estate;
    }
}
